import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import OverOns from "../pages/over-ons/page";
import Contact from "../pages/contact/page";
import Voorwaarden from "../pages/voorwaarden/page";
import Cookies from "../pages/cookies/page";
import Privacy from "../pages/privacy/page";
import VraagGratisAanbod from "../pages/vraag-gratis-aanbod/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/over-ons",
    element: <OverOns />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/vraag-gratis-aanbod",
    element: <VraagGratisAanbod />,
  },
  {
    path: "/voorwaarden",
    element: <Voorwaarden />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
